// removed by extract-text-webpack-plugin
module.exports = {"galleryWrapper":"_2HQdN5_Ayy_0w7Uq3kNLfQ","image":"_3TxxQJdgPj9lqX3EJAY9Bi","video":"_26dJm1awhUZ26QuVmzMBFF","videoBtn":"_34XiS78Trg49i-C8q55twB","fullScreenButton":"EI8E12KuoqZg81CJgpdCQ","quantityTitle":"_3UDIzCivjLuIeuwt2D6O7n","videoLink":"_3jLrbRGsfvDyS3AK9Q4DRH","galleryWrap":"_1y11nUFa-oM2Zzn4jpTDOs"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileInlineGallery/MobileInlineGallery.scss
// module id = 1637
// module chunks = 0